import { resolveMessageSenderId } from './messengerConversationUtils';

const MESSENGER_LAST_OPENED_AT_KEY = 'responder.messenger.lastOpenedAtMs';

const toTimestampMs = (value) => {
  if (!value) return null;
  const next = new Date(value).getTime();
  return Number.isFinite(next) ? next : null;
};

const readMessengerLastOpenedAtMs = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(MESSENGER_LAST_OPENED_AT_KEY);
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
};

const writeMessengerLastOpenedAtMs = (timestampMs) => {
  if (typeof window === 'undefined') return;
  if (!Number.isFinite(timestampMs)) return;
  try {
    window.sessionStorage.setItem(MESSENGER_LAST_OPENED_AT_KEY, `${timestampMs}`);
  } catch (error) {
    // Ignore storage write failures.
  }
};

const resolveEffectiveUnreadCount = (conversation, lastOpenedAtMs, currentUserId = null) => {
  const unreadCount = Number(conversation?.unreadCount ?? conversation?.unread_count ?? 0) || 0;
  if (unreadCount <= 0) return 0;

  const lastMessage = conversation?.lastMessage ?? conversation?.last_message ?? null;
  const lastSenderId = resolveMessageSenderId(lastMessage);
  const shouldSuppressOwnLastMessage =
    currentUserId != null && lastSenderId != null && `${lastSenderId}` === `${currentUserId}`;
  if (shouldSuppressOwnLastMessage) return 0;

  const lastMessageMs = toTimestampMs(conversation?.lastMessageAt ?? lastMessage?.sent_at ?? null);
  const shouldSuppressAsSeen =
    Number.isFinite(lastOpenedAtMs) &&
    Number.isFinite(lastMessageMs) &&
    lastMessageMs <= lastOpenedAtMs;

  return shouldSuppressAsSeen ? 0 : unreadCount;
};

const resolveUnreadTotal = ({
  conversations = [],
  currentUserId = null,
  lastOpenedAtMs = null,
}) => {
  const normalizedUserId = Number(currentUserId);
  if (!Number.isFinite(normalizedUserId)) return 0;

  return (Array.isArray(conversations) ? conversations : []).reduce(
    (total, conversation) =>
      total + resolveEffectiveUnreadCount(conversation, lastOpenedAtMs, currentUserId),
    0,
  );
};

export {
  readMessengerLastOpenedAtMs,
  resolveEffectiveUnreadCount,
  resolveUnreadTotal,
  writeMessengerLastOpenedAtMs,
};
